import { Options } from 'vue-class-component';
import SlotItem from './SlotItem';

@Options({
  name: 'SlotItemOverview',
})
export default class SlotItemOverview extends SlotItem {}
